/**
 * Board Service Headless Pool
 * Using the unified headless pool system from @things-factory/shell
 */

import { getOrCreateHeadlessPool, HEADLESS_POOL_ARGUMENT_SETS } from '@things-factory/shell'

// Create the board pool instance
const boardPool = getOrCreateHeadlessPool('board', {
  min: 2,
  max: 10,
  args: [
    ...HEADLESS_POOL_ARGUMENT_SETS.basic,
    ...HEADLESS_POOL_ARGUMENT_SETS.keychain_safe
  ],
  acquireTimeoutMillis: 15000,
  testOnBorrow: true,
  enableCleanup: true
})

/**
 * Get the board headless pool
 * @returns Pool instance with acquire/release methods
 */
export function getHeadlessPool() {
  return {
    acquire: () => boardPool.acquire(),
    release: (resource: any) => boardPool.release(resource),
    size: 0, // These will be dynamically calculated if needed
    available: 0,
    borrowed: 0,
    pending: 0,
    max: 10,
    min: 2
  }
}